(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-reviews"] && !Shopify.designMode) return;
  try {
    (function() {
  // Multi-image carousel scroll
  document.querySelectorAll('[data-product-reviews] .pr__images--multi').forEach(function(wrapper) {
    var track = wrapper.querySelector('[data-reviews-track]');
    var prev = wrapper.querySelector('[data-reviews-prev]');
    var next = wrapper.querySelector('[data-reviews-next]');
    if (!track || !prev || !next) return;

    function scrollByAmount(direction) {
      var amount = track.clientWidth;
      track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    prev.addEventListener('click', function() {
      scrollByAmount(-1);
    });

    next.addEventListener('click', function() {
      scrollByAmount(1);
    });
  });

  // Lightbox
  var lightbox = document.getElementById('pr-lightbox');
  if (!lightbox) return;

  var lightboxImg = lightbox.querySelector('[data-lightbox-image]');
  var closeBtn = lightbox.querySelector('.pr-lightbox__close');
  var prevBtn = lightbox.querySelector('[data-lightbox-prev]');
  var nextBtn = lightbox.querySelector('[data-lightbox-next]');
  var lastFocusedEl = null;
  var currentGroup = [];
  var currentIndex = 0;

  function updateNav() {
    var hasGroup = currentGroup.length > 1;
    prevBtn.classList.toggle('pr-lightbox__nav--visible', hasGroup);
    nextBtn.classList.toggle('pr-lightbox__nav--visible', hasGroup);
  }

  function showImage(index) {
    currentIndex = index;
    lightboxImg.src = currentGroup[index].src;
    lightboxImg.alt = currentGroup[index].alt || '';
  }

  function openLightbox(triggerBtn) {
    lastFocusedEl = triggerBtn;
    var group = triggerBtn.getAttribute('data-lightbox-group');
    if (group) {
      var groupBtns = document.querySelectorAll('[data-lightbox-group="' + group + '"]');
      currentGroup = [];
      groupBtns.forEach(function(b) {
        currentGroup.push({ src: b.getAttribute('data-lightbox-src'), alt: b.getAttribute('data-lightbox-alt') });
      });
      currentIndex = Array.from(groupBtns).indexOf(triggerBtn);
    } else {
      currentGroup = [{ src: triggerBtn.getAttribute('data-lightbox-src'), alt: triggerBtn.getAttribute('data-lightbox-alt') }];
      currentIndex = 0;
    }
    showImage(currentIndex);
    updateNav();
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }

  function closeLightbox() {
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocusedEl) lastFocusedEl.focus();
    currentGroup = [];
    setTimeout(function() {
      if (lightbox.getAttribute('aria-hidden') !== 'false') {
        lightboxImg.src = '';
      }
    }, 300);
  }

  function goPrev() {
    if (currentGroup.length <= 1) return;
    showImage((currentIndex - 1 + currentGroup.length) % currentGroup.length);
  }

  function goNext() {
    if (currentGroup.length <= 1) return;
    showImage((currentIndex + 1) % currentGroup.length);
  }

  // Only bind to lightbox triggers within product reviews section
  var reviewsSection = document.querySelector('[data-product-reviews]');
  if (reviewsSection) {
    reviewsSection.querySelectorAll('[data-lightbox-trigger]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        openLightbox(btn);
      });
    });
  }

  prevBtn.addEventListener('click', goPrev);
  nextBtn.addEventListener('click', goNext);

  lightbox.querySelectorAll('[data-lightbox-close]').forEach(function(el) {
    el.addEventListener('click', closeLightbox);
  });

  document.addEventListener('keydown', function(e) {
    if (lightbox.getAttribute('aria-hidden') !== 'false') return;
    if (e.key === 'Escape') {
      closeLightbox();
    } else if (e.key === 'ArrowLeft') {
      goPrev();
    } else if (e.key === 'ArrowRight') {
      goNext();
    } else if (e.key === 'Tab') {
      e.preventDefault();
      closeBtn.focus();
    }
  });

  // Touch swipe for lightbox
  var touchStartX = 0;
  var touchStartY = 0;
  var minSwipe = 50;

  lightbox.addEventListener('touchstart', function(e) {
    touchStartX = e.changedTouches[0].screenX;
    touchStartY = e.changedTouches[0].screenY;
  }, { passive: true });

  lightbox.addEventListener('touchend', function(e) {
    var dx = e.changedTouches[0].screenX - touchStartX;
    var dy = Math.abs(e.changedTouches[0].screenY - touchStartY);
    if (Math.abs(dx) > minSwipe && dy < 100) {
      if (dx < 0) { goNext(); } else { goPrev(); }
    }
  }, { passive: true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-specs"] && !Shopify.designMode) return;
  try {
    (function() {
  const specsContainers = document.querySelectorAll('[data-product-specs]');

  specsContainers.forEach(function(container) {
    const tabs = container.querySelectorAll('[data-specs-tab]');
    const panels = container.querySelectorAll('[data-specs-panel]');

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        const targetPanel = tab.dataset.specsTab;

        // Update tabs
        tabs.forEach(function(t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        // Update panels
        panels.forEach(function(panel) {
          if (panel.dataset.specsPanel === targetPanel) {
            panel.classList.add('is-active');
          } else {
            panel.classList.remove('is-active');
          }
        });
      });
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
